import { Box, Flex, Text } from '@chakra-ui/react';
import Button from '~/components/Button';
import {
  useAdvancedFiltersStore,
  useCreatorsFiltersStore,
  useSearchTalentStore,
} from '~/screens/MyAgency/store/';
import { convertPxToRems } from '~/utils-ts';

export const TalentRosterEmptyResults: React.FC = () => {
  const { clearFilters: clearAdvancedFilters } = useAdvancedFiltersStore();
  const { clearAllFilters: clearCreatorsFilters } = useCreatorsFiltersStore();
  const { query, setQuery } = useSearchTalentStore();

  const handleClearAllFilters = () => {
    // do not memoize this function handleClearAllFilters
    // Memoizing this could create issues with the query params and cause old values to be used
    clearAdvancedFilters();
    if (query) setQuery('');
    setTimeout(() => {
      clearCreatorsFilters();
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      track-id={`foam-myagency-nofilteredresultscontainer`}
    >
      <Box textAlign="center" paddingX={convertPxToRems(95)}>
        <Text fontSize="3xl" fontWeight="500" color="primary.300">
          Sorry, we couldn't find any results for your search
        </Text>
        <Text
          fontSize="md"
          fontWeight="400"
          marginTop={convertPxToRems(24)}
          color="primary.500"
        >
          Please try again with different filters
        </Text>
        <Button
          backgroundColor="primary.50"
          color="primary.700"
          borderRadius="5xl"
          width={convertPxToRems(126)}
          marginTop={convertPxToRems(24)}
          onClick={handleClearAllFilters}
          _hover={{ backgroundColor: 'primary.100' }}
          _focusVisible={{ backgroundColor: 'primary.100' }}
          _active={{ backgroundColor: 'primary.200' }}
        >
          Clear Filters
        </Button>
      </Box>
    </Flex>
  );
};
